import { SxProps, Theme } from '@mui/material/styles'
import { hoverBaseStyles } from '../base/hoverBase.styles'

export const customAlertStyles = {
  list: {
    display: 'flex',
    flexDirection: 'column',
    mt: 1.5,
    maxHeight: 320,
    overflowY: 'auto',
  } as SxProps<Theme>,

  divider: {
    borderColor: 'gray.16',
    my: 1.25,
  } as SxProps<Theme>,

  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.25,
  } as SxProps<Theme>,

  title: {
    color: 'text.primary',
    fontWeight: 600,
    ...hoverBaseStyles.textRegular,
  } as SxProps<Theme>,

  description: {
    color: 'text.secondary',
    ...hoverBaseStyles.textRegular,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  } as SxProps<Theme>,

  metadata: {
    color: 'gray.48',
    fontSize: '12px',
    mt: 0.25,
  } as SxProps<Theme>,
}
